import { useState, useEffect } from "react";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import DataTable_Component from "../../components/ordersvehiclereport/Data Table Component/index";
import Status_modal from "../../components/manageInvoice/status_modal/index";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import {
  faEye,
  faPenToSquare,
  faTrash,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";

import Layouts from "../../layouts/layouts";
import Add_data_modal from "../../components/hubs/update_data_modal";
import { Tooltip } from "react-tooltip";
import { Bar } from "react-chartjs-2";
import { Line } from "react-chartjs-2";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import { Chart as ChartJS, registerables } from "chart.js"; // Import Chart.js Core
ChartJS.register(...registerables); // Register chart types and controllers

export default function OrderVehicleReport() {
  const title = "Order Vehicle Report";
  const [apistate, setApiState] = useState([]);
  const [apicol, setApiCol] = useState([]);
  const [selectVal, setSelectval] = useState([]);
  const [openModal, setOpenModal] = useState(true);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isFiltered, setIsFiltered] = useState(false); // Track if filters are applied
  const [orderSummary, setOrderSummary] = useState(null);

  const [open_add_modal, setOpen_add_modal] = useState({
    render: true,
    modal_open: false,
  });

  const [open_update_modal, setOpen_update_modal] = useState({
    render: true,
    modal_open: false,
  });
  const [update_modal_data, setUpdate_modal_data] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [showHubDetailModal, setShowHubDetailModal] = useState(false);
  const [selectedHub, setSelectedHub] = useState(null);

  const brad = [
    {
      name: "Home",
    },
    {
      name: title,
    },
  ];
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };
  const columns = [
    {
      name: <b>Vehicle Number</b>,
      selector: (row) => row.numberplate,
      sortable: true,
    },
    {
      name: <b>Trips</b>,
      selector: (row) => row.trips,
      sortable: true,
    },
    {
      name: <b>On-board Date</b>,
      selector: (row) => formatDate(row.vehicleOnBoardingDate),
      sortable: true,
    },
    {
      name: <b>Location</b>,
      cell: (row) => {
        const tripSummaryValues = row.tripSummary
          ? Object.values(row.tripSummary)
          : [];
        const uniqueHubs = Array.from(
          new Set(tripSummaryValues.map((trip) => trip.hubCityName)),
        );

        return (
          <div style={{ position: "relative", zIndex: 1 }}>
            {uniqueHubs.length > 0 ? <span>{uniqueHubs.join(", ")}</span> : "-"}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: <b>Vehicle Company</b>,
      selector: (row) => row.vehicleCompany,
      sortable: true,
    },
    {
      name: <b>Total Orders</b>,
      selector: (row) => row.totalOrders,
      sortable: true,
    },
    {
      name: <b>Orders Delivered</b>,
      selector: (row) => row.orderDeliver,
      sortable: true,
    },
    {
      name: <b> Un-Delivered Orders</b>,
      selector: (row) => row.totalOrders - row.orderDeliver || "-",
      sortable: true,
    },
    {
      name: <b>Percentage Delivered</b>,
      cell: (row) => {
        const { totalOrders = 0, orderDeliver = 0 } = row;
        const percentage =
          totalOrders > 0
            ? ((orderDeliver / totalOrders) * 100).toFixed(2)
            : "0";
        return <span>{percentage}%</span>;
      },
      sortable: true,
    },
    {
      name: <b>Individual Km</b>,
      selector: (row) => row.kmDriven,
      sortable: true,
    },
    {
      name: <b>Individual Amount</b>,
      selector: (row) => row.amount,
      sortable: true,
    },
    {
      name: <b>Hub Name</b>,
      cell: (row) => {
        const tripSummaryValues = row.tripSummary
          ? Object.values(row.tripSummary)
          : [];
        const uniqueHubs = Array.from(
          new Set(tripSummaryValues.map((trip) => trip.hub)),
        );

        return (
          <div style={{ position: "relative", zIndex: 1 }}>
            {uniqueHubs.length > 0 ? (
              <>
                <span>{uniqueHubs.join(", ").slice(0, 20)}...</span>
                <FontAwesomeIcon
                  icon={faInfoCircle}
                  data-tooltip-id={`tooltip-hub-name-${row.userId}`}
                  data-tooltip-content={uniqueHubs.join(", ")}
                  style={{ cursor: "pointer", marginLeft: "5px" }}
                />
                <Tooltip
                  id={`tooltip-hub-name-${row.userId}`}
                  place="bottom"
                  style={{ zIndex: 9999, backgroundColor: "black" }}
                />
              </>
            ) : (
              "-"
            )}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: <b>Delivered Hub Wise</b>,
      cell: (row) => {
        const tripSummaryValues = row.tripSummary
          ? Object.values(row.tripSummary)
          : [];
        const uniqueHubs = Array.from(
          new Set(tripSummaryValues.map((trip) => trip.deliver)),
        );

        return (
          <div style={{ position: "relative", zIndex: 1 }}>
            {uniqueHubs.length > 0 ? (
              <>
                <span>{uniqueHubs.join(", ").slice(0, 20)}...</span>
                <FontAwesomeIcon
                  icon={faInfoCircle}
                  data-tooltip-id={`tooltip-hub-name-${row.userId}`}
                  data-tooltip-content={uniqueHubs.join(", ")}
                  style={{ cursor: "pointer", marginLeft: "5px" }}
                />
                <Tooltip
                  id={`tooltip-hub-name-${row.userId}`}
                  place="bottom"
                  style={{ zIndex: 9999, backgroundColor: "black" }}
                />
              </>
            ) : (
              "-"
            )}
          </div>
        );
      },
      sortable: true,
    },
  ];

  const fetchData = async (filterFromDate = "", filterToDate = "") => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }

      let url = `${process.env.REACT_APP_BASE_URL}/api/v3/orders-consolidate/vehicle-summary`;
      //     let url = `${process.env.REACT_APP_BASE_URL}/api/v1/orders/vehicle-summary/consolidation`;

      const params = {};
      if (filterFromDate && filterToDate) {
        params.dateFrom = filterFromDate;
        params.dateTo = filterToDate;
      } else {
        // Default: fetch data for the previous month
        const today = new Date();
        const firstDayOfPrevMonth = moment(today)
          .subtract(1, "month")
          .startOf("month")
          .format("YYYY-MM-DD");
        const lastDayOfPrevMonth = moment(today)
          .subtract(1, "month")
          .endOf("month")
          .format("YYYY-MM-DD");
        params.dateFrom = firstDayOfPrevMonth;
        params.dateTo = lastDayOfPrevMonth;
      }

      const response = await axios.get(url, {
        params,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const { orderSummary } = response.data;
      setOrderSummary(orderSummary);

      if (orderSummary && Array.isArray(orderSummary.vehicleSummary)) {
        const vehicleData = orderSummary.vehicleSummary.map((vehicle) => ({
          ...vehicle,
          totalTrips: orderSummary.totalTrips,
          totalKm: orderSummary.totalKm,
          totalAmount: orderSummary.totalAmount,
        }));

        setApiState(vehicleData);
      } else {
        console.error("Unexpected data format: ", orderSummary.vehicleSummary);
      }

      setApiCol(columns);
    } catch (error) {
      if (error.response) {
        console.error("API Error Response:", error.response.data);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Request setup error:", error.message);
      }
    }
  };

  const handleFilterApply = (filterFromDate, filterToDate) => {
    setIsFiltered(true); // Mark that filters are applied
    setFromDate(filterFromDate);
    setToDate(filterToDate);
    fetchData(filterFromDate, filterToDate); // Fetch filtered data
  };
  const handleRemoveFilters = () => {
    setFromDate("");
    setToDate("");
    fetchData();
  };

  useEffect(() => {
    if (!isFiltered) {
      fetchData();
    }
  }, [isFiltered]);

  // const chartData = {
  //   labels: apistate.map((vehicle) => vehicle.numberplate),
  //   datasets: [
  //     {
  //       label: "Orders per Vehicle",
  //       data: apistate.map((vehicle) => vehicle.orderDeliver), // Data for plotting
  //       fill: false, // Line without fill under it
  //       borderColor: "rgba(75, 192, 192, 1)", // Line color
  //       backgroundColor: "rgba(75, 192, 192, 0.4)", // Point background color
  //       tension: 0.4, // Smoothness of the line curve
  //       pointBackgroundColor: "rgba(75, 192, 192, 1)", // Color for data points
  //       pointBorderColor: "#fff",
  //       pointRadius: 5, // Size of the points on the line
  //     },
  //   ],
  // };

  const chartData = {
    labels: apistate.map((vehicle) => vehicle.numberplate),
    datasets: [
      {
        label: "Orders per Vehicle",
        data: apistate.map((vehicle) =>
          vehicle.trips <= vehicle.orderDeliver
            ? vehicle.trips
            : vehicle.orderDeliver,
        ),
        fill: false, // Line without fill under it
        borderColor: "rgba(75, 192, 192, 1)", // Line color
        backgroundColor: "rgba(75, 192, 192, 0.4)", // Point background color
        tension: 0.4, // Smoothness of the line curve
        pointBackgroundColor: "rgba(75, 192, 192, 1)", // Color for data points
        pointBorderColor: "#fff",
        pointRadius: 5, // Size of the points on the line
      },
    ],
  };

  const setStoreBtn = () => {
    setOpen_add_modal({ render: !open_add_modal.render, modal_open: true });
  };

  const setUpdateStoreBtn = (row) => {
    setOpen_update_modal({
      render: !open_update_modal.render,
      modal_open: true,
    });
    setUpdate_modal_data(row);
  };

  const exportToExcel = () => {
    if (!orderSummary) return;

    const wsData = [];

    // ===== Title =====
    wsData.push(["Vehicle Report"]);
    wsData.push([
      `From: ${moment(orderSummary.date.dateFrom).format("DD-MM-YYYY")}  To: ${moment(
        orderSummary.date.dateTo,
      ).format("DD-MM-YYYY")}`,
    ]);

    wsData.push([]);

    // ===== Overall Summary =====
    wsData.push(["Overall Summary"]);
    wsData.push(["Total Trips", orderSummary.totalTrips]);
    wsData.push(["Total Orders", orderSummary.totalOrders]);
    wsData.push(["Total KM", orderSummary.totalKm]);
    wsData.push(["Total Amount", orderSummary.totalAmount]);
    wsData.push(["Total Cancel Amount", orderSummary.totalCancelAmount]);
    wsData.push(["Total Missed Amount", orderSummary.totalMissedAmount]);

    wsData.push([]);
    wsData.push([]);

    // ===== Vehicle Header =====
    wsData.push([
      "Vehicle Number",
      "OnBoard Date",
      "Feet",
      "Company",
      "Vehicle Name",
      "Vehicle Type",
      "Trips",
      "Orders",
      "KM Driven",
      "Amount",
      "Cancel Amount",
      "Missed Amount",
      "Delivered",
      "Undelivered",
    ]);

    // ===== Vehicle Data =====
    orderSummary.vehicleSummary.forEach((vehicle) => {
      wsData.push([
        vehicle.numberplate,
        moment(vehicle.vehicleOnBoardingDate).format("DD-MM-YYYY"),
        vehicle.feet,
        vehicle.vehicleCompany,
        vehicle.vehicleName,
        vehicle.vehicleType,
        vehicle.trips,
        vehicle.totalOrders,
        vehicle.kmDriven,
        vehicle.amount,
        vehicle.cancelAmount,
        vehicle.missedAmount,
        vehicle.orderDeliver,
        vehicle.orderUndelivered,
      ]);
    });

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Optional: Set column widths
    ws["!cols"] = [
      { wch: 18 },
      { wch: 20 },
      { wch: 25 },
      { wch: 12 },
      { wch: 10 },
      { wch: 10 },
      { wch: 12 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 12 },
      { wch: 15 },
      { wch: 15 },
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Vehicle Report");

    XLSX.writeFile(
      wb,
      `Vehicle_Report_${moment().format("YYYYMMDD_HHmmss")}.xlsx`,
    );
  };

  return (
    <>
      <Layouts />
      <Status_modal row={selectVal} openModal={openModal} />
      <Add_data_modal
        select_data={update_modal_data}
        open_update_data_modal={open_update_modal}
      />
      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              <div className="card-header d-flex justify-content-between border-bottom pb-1">
                <h4>{title}</h4>
                <div>
                  <button
                    onClick={exportToExcel}
                    className="btn btn-success btn-sm text-white"
                  >
                    Export to Excel
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div
                  className="my-4"
                  style={{ height: "500px", width: "100%" }}
                >
                  {" "}
                  {apistate.length > 0 ? (
                    <Line
                      data={chartData}
                      options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                          x: {
                            ticks: {
                              font: {
                                size: 12,
                              },
                            },
                          },
                          y: {
                            ticks: {
                              font: {
                                size: 12,
                              },
                            },
                          },
                        },
                      }}
                    />
                  ) : (
                    <p>Loading...</p>
                  )}
                </div>
                {apistate.length > 0 ? (
                  <DataTable_Component
                    searchBy="numberplate"
                    title_btn={true}
                    title="Vehicle List"
                    apidata={apistate}
                    columns={apicol}
                    onFilterApply={handleFilterApply}
                  />
                ) : (
                  <p>Loading...</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
